import Route from '@ember/routing/route';

export default class TextMessagesRoute extends Route {}
